import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { AddressContainer } from "@/components/Address/Address/address.container";
import { useAddressBook } from "@/components/Checkout/CheckoutCustomer/addresses/context/addressBook.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    address?: CloudCustomerAddress;
    addressType: AddressType;
    className?: string;
};

export const StaticAddress = ({ address, addressType, className }: Props) => {
    const { t } = useGranite();

    const { openAddressList } = useAddressBook();

    const handlOnEditClick = () => {
        if (!address) return;

        openAddressList({ type: addressType, id: address.id, disabledIds: [] });
    };

    if (!address) return null;

    return (
        <div className={cn(className)}>
            <div className={"mb-2"}>
                <AddressContainer
                    address={address}
                    addressType={addressType}
                />
            </div>
            <Button
                test={"customerDetails-address-button-edit"}
                className={"px-0"}
                color={"link"}
                type={"button"}
                onClick={handlOnEditClick}
            >
                <i className={"las la-pencil-alt mr-2"} />
                {t(
                    `checkout.customerDetails.customerInfo.address.${addressType}.edit.link`
                )}
            </Button>
        </div>
    );
};
